import { IconProps } from "./types";
import React from "react";

export const EdgeIcon = ({
  className,
  fill = "currentColor",
  width = 20,
  height = 20,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 100 50"
    className={className}
    style={style}
  >
    <g>
      <path
        fill={fill || "#1f201d"}
        d="M53.48,16.09v2.3h4.5v2.98h-4.5v2.54h5.1v3.14h-9.01v-14.09h9.01v3.14h-5.1Z"
      />
      <path
        fill={fill || "#1f201d"}
        d="M69.97,13.84c1.11.59,1.97,1.42,2.57,2.49s.9,2.29.9,3.66-.3,2.57-.91,3.64-1.47,1.9-2.58,2.51-2.4.91-3.87.91h-5.58v-14.09h5.58c1.48,0,2.77.3,3.89.89h0ZM68.48,22.65c.65-.63.98-1.51.98-2.66s-.33-2.06-.98-2.69c-.65-.63-1.55-.95-2.7-.95h-1.36v7.23h1.36c1.15,0,2.05-.31,2.7-.94h0Z"
      />
      <path
        fill={fill || "#1f201d"}
        d="M84.19,17.59c-.23-.37-.54-.66-.93-.86s-.86-.3-1.39-.3c-.99,0-1.76.32-2.33.96s-.85,1.5-.85,2.58c0,1.21.3,2.14.91,2.77.61.63,1.49.95,2.65.95,1.37,0,2.35-.62,2.94-1.86h-3.94v-2.82h7.31v3.8c-.31.75-.76,1.45-1.35,2.1s-1.34,1.19-2.25,1.61-1.94.63-3.1.63c-1.41,0-2.66-.3-3.75-.91s-1.93-1.45-2.52-2.54-.89-2.33-.89-3.73.3-2.62.89-3.71,1.43-1.93,2.51-2.54,2.33-.91,3.74-.91c1.77,0,3.24.43,4.4,1.28,1.16.85,1.88,2.02,2.16,3.5h-4.22,0Z"
      />
      <path
        fill={fill || "#1f201d"}
        d="M94.44,16.09v2.3h4.5v2.98h-4.5v2.54h5.1v3.14h-9.01v-14.09h9.01v3.14h-5.1Z"
      />
    </g>
    <g>
      <polygon
        fill={fill || "#008aff"}
        points="19.92 20 39.39 20 39.39 1.51 19.92 20"
      />
      <g>
        <polygon
          fill={fill || "#004792"}
          points=".46 38.49 19.92 38.49 19.92 20 .46 38.49"
        />
        <polygon
          fill={fill || "#004792"}
          points="19.92 38.49 39.39 38.49 39.39 20 19.92 38.49"
        />
      </g>
    </g>
  </svg>
);
